import regionConfig from '@/data/regionConfig.json'
import _ from 'lodash'

export default class addressService {
  getCountryConfig (countryCode) {
    const normalizedCountryConfig = this.getNormalizedCountryConfig(countryCode)
    return normalizedCountryConfig
  }

  getNormalizedCountryConfig (countryCode) {
    const rawCountryConfig = this.getRawCountryConfig(countryCode)
    return {
      addressFieldsSortOrder: rawCountryConfig.addressFieldsSortOrder,
      address: (rawCountryConfig.rules && rawCountryConfig.rules.address) || {}
    }
  }

  getRawCountryConfig (countryCode) {
    let rawCountryConfig = _.merge({}, regionConfig.DEFAULT, regionConfig[countryCode])
    return rawCountryConfig
  }
}
